import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DashboardDetailsStore {

}

export enum DashboardDetailsStoreKeys {

}
